import EntityBase from '@/data/EntityBase';

import { Map } from 'immutable';

export default class ForecastCustomUnitState extends EntityBase({
  items: new Map(),
}) {}
